<template>
  <div class="product" v-show="Searched">
      <div class="imagaa">
        <img v-if="product.image.includes('data')" :src="product.image" width="100" height="100">
        <img v-else :src="this.$api + 'img/settings/product/' + product.image" width="100" height="100">
      </div>
      <div class="left">
        <div>
          {{ product.name }} {{ product.inhoud }}
        </div>
        <div class="cart">
          <div @click="remove(_uid)" :id="'remove-' + _uid">
            <i class="fas fa-arrow-circle-left"></i>
          </div>
          <div v-if="aantal != 0" v-bind:class="{ cartshow : aantal > 0, cartremove : aantal < 0 }">
            <div @click="openaantal(_uid)" :id="'open-' + _uid">
              <i class="fas fa-shopping-cart"></i> {{ aantal }}
            </div>
          </div>
          <div v-else class="empty"></div>
          <div @click="add(_uid)" :id="'add-' + _uid">
            <i class="fas fa-arrow-circle-right"></i>
          </div>
        </div>
      </div>

      <div class="modal is-active" v-if="showaantal">
        <div class="modal-background"></div>
        <div class="modal-content" style="padding:20px; color:#ffffffc7">
          <i class="fas fa-cubes"></i> Verander aantal:
          <input class="input" type="text" v-model="aantal">
        </div>
        <button class="modal-close is-large" aria-label="close" @keydown.esc="showaantal = false" @click="showaantal = false"></button>
      </div>

      <hr />
  </div>
</template>

<script>
export default {
  name: 'Product',

  props: ['product', 'search', 'cart'],

  data() {
    return {
      aantal: 0,
      showaantal: false
    }
  },

  methods: {
    add(id) {
      this.aantal += 1;
      this.flash('add-' + id);
    },

    openaantal(id) {
      if(this.showaantal)
        this.showaantal = false;
      else 
        this.showaantal = true;

      this.flash('open-' + id);
    },

    remove(id) {
      this.aantal -= 1;
      this.flash('remove-' + id);
    },

    flash(id) {
      $('#' + id).addClass('flash');
      setTimeout(function() {
            $('#' + id).removeClass('flash');
      }, 250);
    }
  },

  computed: {
    Searched() {
      if(this.search == '')
        return true;

      if (this.product.factuurnaam.toLowerCase().includes(this.search.toLowerCase())) {
        return true;
      }

      if (this.product.name.toLowerCase().includes(this.search.toLowerCase())) {
        return true;
      }

      return false;
    }
  },

  mounted() {
    for (var i = this.cart.length - 1; i >= 0; i--) {
        if(this.cart[i].id == this.product.id)
        {
          this.aantal = this.cart[i].aantal;
        }
      }
  },

  watch: {
    aantal: function() {
      if(this.aantal != '')
        this.aantal = parseInt(this.aantal);
      
      this.$emit('changed', [this.aantal, this.product]);
    }, 
    cart: function () {
      
    }
  },

}
</script>

<style>
  .cartremove {
    color:#941515;
  }

  .cartshow {
    color: #15944f;
  }

  .empty {
    min-width:58.14px;
  }

  .cart {
    font-size:30px;
  }

  .cart div {
    display:inline-block;
  }
  
  .cart .fa-arrow-circle-left {
    margin-right:35px;
  }

  .cart .fa-arrow-circle-right {
    margin-left:35px;
  }

  .imagaa {
    display: inline-block;
    vertical-align: top;
    width:100px;
  }

  .left {
    padding:20px;
    display: inline-block;
    vertical-align: top;
    width: 250px;
  }
</style>
